<template>
<div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  data(){
    return{

    }
  },
  methods:{


  },
  created() {}
}
</script>


<style lang="less">
@import "./assets/css/common.css";
@import "./assets/css/bigscreen.css";
/*1rem=10px*/
@import "./assets/css/comm_wap.css";

/* 标题字体 */
@font-face {
  font-family: "MGQ8102";
  src: url("./assets/fonts/MGQ8102.ttf");
}

/* 正文字体 */
@font-face {
  font-family: "MHR8102";
  src: url("./assets/fonts/MHR8102.ttf");
}

/* 蒙科立字体 */
@font-face {
  font-family: "MenksoftQagan";
  src: url("./assets/fonts/MenksoftQagan.ttf");
}

.titlefont {
  font-family: "MGQ8102" !important;
}

.contentfont {
  //font-family: "MHR8102" !important;
  font-family: "MenksoftQagan" !important;
}


@font-face {
  font-family: "OrhonChaganTig";
  src: url("./assets/fonts/OrhonChaganTig.ttf") format("truetype");
}
@font-face {
  font-family: "OrhonHawangTig";
  src: url("./assets/fonts/OrhonHawangTig.ttf") format("truetype");
}

@font-face {
  font-family: "OrhonChaganTig-H";
  src: url("./assets/fonts/OrhonChaganTig-H.ttf") format("truetype");
}

@font-face {
  font-family: "OrhonChaganTig-RTL";
  src: url("./assets/fonts/OrhonChaganTig-RTL.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "OrhonChaganTig-V";
  src: url("./assets/fonts/OrhonChaganTig-V.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "OrhonGarchagTig";
  src: url("./assets/fonts/OrhonGarchagTig.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "OrhonGarchagTig-H";
  src: url("./assets/fonts/OrhonGarchagTig-H.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "OrhonGarchagTig-RTL";
  src: url("./assets/fonts/OrhonGarchagTig-RTL.ttf") format("truetype");
}

@font-face {
  font-family: "OrhonGarchagTig-V";
  src: url("./assets/fonts/OrhonGarchagTig-V.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "OrhonCaiyunTig";
  src: url("./assets/fonts/OrhonCaiyunTig.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}

* {
  margin: 0;
  padding: 0;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
}
/* 元素竖排 */
.aqt_su {
  writing-mode: vertical-lr;
}

/* 元素取消竖排 */
.aqt_no_su {
  writing-mode: horizontal-tb;
}

/* 蒙语字竖起来的属性 */
.aqt_lang_mn {
  writing-mode: vertical-lr;
  text-orientation: sideways-right;
  text-orientation: sideways !important;
  -o-text-orientation: sideways !important;
  -ms-text-orientation: sideways !important;
  -moz-text-orientation: sideways !important;
  -webkit-text-orientation: sideways !important;
  -webkit-text-orientation: sideways-right !important;
}

/* 上下左右剧中 */
.aqt_ce_ve {
  display: flex;
  width: 100%;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  display: -ms-flexbox;
  justify-content: center;
}


//禁止图片拖拽
img{
  -webkit-user-drag: none; /* Safari */
  -khtml-user-drag: none; /* Konqueror */
  -moz-user-drag: none; /* Firefox */
  -o-user-drag: none; /* Opera */
  user-drag: none; /* 其他浏览器 */
}


.demo-drawer-footer{
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}

.textarea_mn{
  writing-mode: vertical-lr;
  height: 200px!important;
  border: 1px solid #dcdee2!important;
  line-height: 1.5!important;
  padding:8px 5px!important;
  width: 100% !important;
  color: #515a6e!important;
  border-radius: 4px!important;
  font-size: 14px!important;
  resize: none!important;
  text-orientation: sideways-right;
  text-orientation: sideways !important;
  -o-text-orientation: sideways !important;
  -ms-text-orientation: sideways !important;
  -moz-text-orientation: sideways !important;
  -webkit-text-orientation: sideways !important;
  -webkit-text-orientation: sideways-right !important;
}
textarea:focus {
  border-color: #57a3f3!important; /* 点击（聚焦）时的边框颜色 */
  outline: none!important; /* 去除浏览器默认的聚焦样式 */
}
textarea::placeholder{
  color: #c5c8ce!important;
}

/*表格公共样式*/
.ivu-table-cell{
  padding: 0px 5px!important;
  /*word-wrap: break-word!important;*/
  /*word-break: break-word!important;*/
}

</style>
